
























































































































































































































import { Component, Mixins, Ref, Watch } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import { PatientDispInfo } from "@/components/patient/types";
import FireStoreMixin from "@/mixins/firestoreMixin";
import UtilMixin from "@/mixins/utilMixin";
import BaseVisit from "@/views/BaseVisit";
import PatientMixin from "@/mixins/patientMixin";
import PatientInfoDialog from "@/components/patient/PatientInfoDialog.vue";
import PatientMemoDialog from "@/components/patient/PatientMemoDialog.vue";
import DateMixin from "#/mixins/dateMixin";
import { LinkShowReport } from "@/components/visit/types";

@Component({
  components: {
    PatientInfoDialog,
    PatientMemoDialog
  }
})
export default class VisitHeader extends Mixins(
  AxiosMixin,
  UtilMixin,
  FireStoreMixin,
  PatientMixin,
  BaseVisit,
  DateMixin
) {
  @Ref("header") readonly header!: HTMLElement;

  @Ref("patientInfoDialog")
  private readonly patientInfoDialog!: PatientInfoDialog;

  @Ref("patientMemoDialog")
  private readonly patientMemoDialog!: PatientMemoDialog;

  // 長い名前が設定された場合の表示ずれを直す
  @Watch("info") private changeInfo() {
    setTimeout(this.observeExpandMenuButtons, 360);
  }

  @Watch("linkShowReports") private changeMenuButtons() {
    setTimeout(this.observeExpandMenuButtons, 120);
  }

  @Watch("$route.path") private changeRoute() {
    setTimeout(this.observeExpandMenuButtons, 120);
  }

  @Watch("isNeedTitleNextLine") private changeNextLineTitle() {
    setTimeout(this.observeExpandMenuButtons, 120);
  }

  /** アイコンエリアの幅 */
  private widthIconArea = 0;
  /** 訪問メモダイアログを訪問終了時にも表示するかどうか */
  public isDispMemoEnd = 1;
  /** 移動中:0 訪問中:1  */
  public mode = 0;

  /** 訪問開始前の書類確認リンク */
  protected linkShowReports: LinkShowReport[] = [];

  /** 訪問開始前の書類確認リンク：幅に収まらなかったメニュー入りリスト */
  protected linkSecondShowReports: LinkShowReport[] = [];

  /**
   * タイトルの最大幅は、アイコンエリアの幅とボタン最小幅を引いた分
   * @todo デザインの変更や仕様変更に応じて調整が必要
   */
  private get maxWidthTitle() {
    const buttonsWidth = 150;
    return `calc(100% - ${buttonsWidth + this.widthIconArea}px)`;
  }

  /** アイコンエリアを表示するか */
  private get isShowIconArea() {
    return (
      this.info.is_med ||
      this.info.is_emargency ||
      (this.isHonobonoAgreement && !this.info.is_honobono) ||
      this.info.group_icons.length > 0
    );
  }

  /**
   * 利用者名などタイトルを最低600px未満で折り返す
   * 状態バッジやグループアイコンのありかによっては少し広い幅でも折り返される
   */
  private get isNeedTitleNextLine() {
    const breakPoint = 600 + this.widthIconArea;
    return this.$vuetify.breakpoint.width < breakPoint;
  }

  /** パネル展開状態 */
  private openedPanels: number[] = [];

  /** 利用者情報 */
  private get info(): PatientDispInfo {
    return this.patientInfo;
  }

  /** ヘッダーのタイトル */
  private get Title(): string {
    return this.info.name;
  }

  public async created() {
    this.patientId = Number(this.$route.params.id);
    new Promise(this.fetchPatientLink).then(() => {
      this.linkSecondShowReports.splice(0);
      this.linkShowReports = [
        {
          label: "24時間体制",
          isEnable: this.linkCondition.exist_hour24,
          access: this.clickHour24
        },
        {
          label: "最新計画書",
          isEnable: this.linkCondition.latest_vn_plant_id > 0,
          access: this.clickLatestVnPlan
        },
        {
          label: "フェイスシート",
          isEnable: true,
          access: this.clickFaceSheet
        },
        {
          label: "前月報告書",
          isEnable: this.linkCondition.before_month_report_id > 0,
          access: this.clickBeforeMonthReport
        },
        {
          label: "前3回の記録(リハ)",
          isEnable: this.linkCondition.last3_rehab_record_ids.length > 0,
          access: this.clickLast3TimesRecordRehab
        },
        {
          label: "前3回の記録(看護)",
          isEnable: this.linkCondition.last3_nursing_record_ids.length > 0,
          access: this.clickLast3TimesRecordNursing
        },
        {
          label: "前3回のADL",
          isEnable: this.linkCondition.exist_last3_adl,
          access: this.clickLast3TimesAdl
        },
        {
          label: "最新記録書Ⅰ",
          isEnable: this.linkCondition.latest_vnrecord_pdf_path !== "",
          access: this.clickLatestVnrecord
        },
        {
          label: "経過観察",
          isEnable: this.linkCondition.exsit_progress,
          access: this.clickProgress
        }
      ];
    });
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  private resizeWatcher: any = null;

  /** 訪問へ行くヘッダーのボタンを画面幅に収める */
  private observeExpandMenuButtons(): void {
    // ラッパーにはflex-wrap: nowrapが必要
    // 子孫中のテキストにはwhite-space: nowrapが要るかも
    // 子要素には水平marginを使わない、幅計算が狂ってしまう
    const wrapper = document.querySelector(".ibow2-visit-header-menu");
    // 溢れそうな時に隠す要素はラッパーの子
    const hidables = document.querySelectorAll(
      ".ibow2-visit-header-menu > .ibow2-visit-header-menu-hidable"
    );
    // 隠したのを収める要素はラッパーの子孫
    const expanders = document.querySelectorAll(
      ".ibow2-visit-header-menu .ibow2-visit-header-menu-expander"
    );
    // 隠すでも展開メニューでもない要素
    const others = document.querySelectorAll(
      ".ibow2-visit-header-menu > :not(.ibow2-visit-header-menu-hidable):not(.ibow2-visit-header-menu-expander)"
    );

    // 利用者情報の取得後なら、アイコンエリアの幅が分かる
    const iconAreaElem = document.querySelector(".ibow2-visit-header-icon");
    if (iconAreaElem?.clientWidth) {
      this.widthIconArea = iconAreaElem.clientWidth;
    }

    /**
     * まずは全子要素のdisplayを元通りに
     * hidablesでもexpandersでもない子要素の合計幅を求めて幅Aとする
     * expandersである要素の合計幅を求めて幅Bとする
     * 幅Aにhidablesな要素を一つずつ足していく
     *   この時幅Aがラッパーの幅 - 幅Bを超えたら、その要素を隠す要素リストCに入れる
     * 要素リストCに入れた要素を隠す
     * expandersは、要素リストCがあれば表示、無ければ隠す
     * primaryButtonsラベルリストの中で、後ろから[要素リストCの数]だけsecondaryLabelにも複製
     */
    const buttonPosSwitch = () => {
      if (wrapper == null) return;
      const wrapperWifdth = wrapper.clientWidth;

      // まずは全子要素のdisplayを元通りに
      [...wrapper.children].forEach(child => {
        (child as HTMLElement).style.display = "";
      });

      // hidablesでもexpandersでもない子要素の合計幅を求めて幅Aとする
      let childsBaseWidth = 0;
      others.forEach(other => {
        childsBaseWidth += other.clientWidth;
      });

      // expandersである要素の合計幅を求めて幅Bとする
      let expanderWidth = 0;
      expanders.forEach(expander => {
        expanderWidth += expander.clientWidth;
      });

      // 幅Aにhidablesな要素を一つずつ足していく
      //   この時幅Aがラッパーの幅 - 幅Bを超えたら、その要素を隠す要素リストCに入れる
      const hidableMaxSpace = wrapperWifdth - childsBaseWidth - expanderWidth;
      let hidableWidth = 0;
      const secondaryElems: Node[] = [];
      hidables.forEach(hider => {
        hidableWidth += hider.clientWidth;
        if (hidableWidth > hidableMaxSpace) {
          secondaryElems.push(hider);
        }
      });

      // 要素リストCに入れた要素を隠す
      secondaryElems.forEach(hider => {
        (hider as HTMLElement).style.display = "none";
      });

      // expandersは、要素リストCがあれば表示、無ければ隠す
      if (secondaryElems.length >= 1) {
        expanders.forEach(expander => {
          (expander as HTMLElement).style.display = "";
        });
      } else {
        expanders.forEach(expander => {
          (expander as HTMLElement).style.display = "none";
        });
      }

      // primaryButtonsラベルリストの中で、後ろから[要素リストCの数]だけsecondaryLabelにも複製
      this.linkSecondShowReports.splice(0);
      if (secondaryElems.length >= 1) {
        this.linkSecondShowReports.push(
          ...this.linkShowReports.slice(-secondaryElems.length)
        );
      }
    };

    // ラッパーの幅変化を検知する
    // 何も触らないとResizeObserverが働かないため、一度はすぐに幅変化を実行
    buttonPosSwitch();
    // 以前のResizeObserverは解除
    this.resizeWatcher?.disconnect?.();
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.resizeWatcher = new (window as any).ResizeObserver(buttonPosSwitch);
    // ラッパーの幅変化を検知する
    if (wrapper != null) this.resizeWatcher.observe(wrapper);
  }
}
